import { queryOptions } from "@tanstack/react-query";

import type { IAppsFilterOptionsDto } from "app/pages/sales-intelligence/domain/apps/types/filter-options";
import salesApiService from "app/pages/sales-intelligence/services/salesApiService";
import salesSettingsHelper from "app/pages/sales-intelligence/services/salesSettingsHelper";

import { appsQueryKeys } from "./queryKeyFactory";

type Options<T = IAppsFilterOptionsDto> = {
    select?: (data: IAppsFilterOptionsDto) => T;
    enabled?: boolean;
};

export const createAppsFilterDescriptionQuery = <T = IAppsFilterOptionsDto>({ select, enabled }: Options<T> = {}) =>
    queryOptions<IAppsFilterOptionsDto, Error, T>({
        enabled: enabled ?? salesSettingsHelper.isConsolidatedAppsEnabled,
        staleTime: Number.POSITIVE_INFINITY,
        queryKey: appsQueryKeys.filterDescription(),
        queryFn: ({ signal }) => salesApiService.apps.fetchFilterDescription({ cancellation: signal }),
        select,
    });
